<app-carousel-flat
  [heading]="'Sports'"
  [items]="categories"
  link="/browse-categories"
  [itemsPerSlide]="itemsPerSlide"
  [showIndicators]="isMobile"
  [showPagination]="!isMobile"
>
  <ng-template let-item="item">
    <app-category [category]="item"></app-category>
  </ng-template>
</app-carousel-flat>
